var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10.68 8.52" }, props),
    React.createElement(
      "title",
      null,
      "slider_arrow_left_white"
    ),
    React.createElement("path", { d: "M3.49 4.11a.2.2 0 0 1 0-.24L6.31.3a.11.11 0 0 1 .19 0 .21.21 0 0 1 0 .24L3.9 3.82h6.38c.07 0 .13.08.13.17s-.06.17-.13.17h-6.4l2.6 3.28a.21.21 0 0 1 0 .24.11.11 0 0 1-.19 0z", fill: "#eaf1f3" }),
    React.createElement("path", { d: "M3.49 4.11a.2.2 0 0 1 0-.24L6.31.3a.11.11 0 0 1 .19 0 .21.21 0 0 1 0 .24L3.9 3.82h6.38c.07 0 .13.08.13.17s-.06.17-.13.17h-6.4l2.6 3.28a.21.21 0 0 1 0 .24.11.11 0 0 1-.19 0z", fill: "none", stroke: "#fff", strokeMiterlimit: "10", strokeWidth: ".5" }),
    React.createElement("path", { fill: "none", stroke: "#fff", d: "M.5.54v7.98" })
  );
});